import React, { useState } from "react";
import { Badge, Button } from "reactstrap";
import MainComponent from "components/MainComponent";
import MaterialPricing from "./MaterialPricing/MaterialPricing";
import CrewPricing from "./CrewPricing/CrewPricing";
import CartingPricing from "./Carting/CartingPricing";
import PublishCenter from "./MaterialPricing/PublishCenter";
import SyncStatusPanel from "./MaterialPricing/SyncStatusPanel";
import { useSyncStatus } from "./MaterialPricing/hooks/useSyncStatus";
import styles from "./MasterPricing.module.scss";

const TABS = [
  { key: "material", label: "Material Pricing", component: MaterialPricing },
  { key: "crew", label: "Sub / Crew Pricing", component: CrewPricing },
  { key: "carting", label: "Carting Pricing", component: CartingPricing },
];

function MasterPricing() {
  const [activeTab, setActiveTab] = useState("material");
  const [isPublishOpen, setIsPublishOpen] = useState(false);

  // Track which tabs have been visited so we only mount them once they're first opened.
  // Once mounted, they stay mounted (preserves state, avoids re-fetching on tab switch).
  const [visited, setVisited] = useState({ material: true });

  const handleTabClick = (key) => {
    setActiveTab(key);
    setVisited((prev) => ({ ...prev, [key]: true }));
  };

  const { data: syncData } = useSyncStatus();
  const masterStatus = syncData?.masterStatus || {
    material: 0,
    labor: 0,
    carting: 0,
  };
  const pendingMasterCount = Object.values(masterStatus).reduce(
    (a, b) => a + b,
    0
  );

  return (
    <MainComponent>
      <PublishCenter
        isOpen={isPublishOpen}
        toggle={() => setIsPublishOpen(false)}
        masterStatus={masterStatus}
      />

      <div className="_container_right _user_page">
        <div className="__proposal">
          <div style={{ margin: "2% 2% 0" }}>
            <div className={styles.header}>
              <nav className={styles.tabs}>
                {TABS.map((tab) => (
                  <button
                    key={tab.key}
                    className={`${styles.tab} ${activeTab === tab.key ? styles.active : ""}`}
                    onClick={() => handleTabClick(tab.key)}
                  >
                    {tab.label}
                  </button>
                ))}
              </nav>

              <div className={styles.actions}>
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => setIsPublishOpen(true)}
                >
                  <i className="fa fa-paper-plane mr-1" />
                  Publish Updates
                  {pendingMasterCount > 0 && (
                    <Badge color="danger" className="ml-1" pill>
                      {pendingMasterCount}
                    </Badge>
                  )}
                </Button>
                <SyncStatusPanel />
              </div>
            </div>
            <br />
            {/* Render tab content only after first visit, hide instead of unmount on switch */}
            {TABS.map((tab) =>
              visited[tab.key] ? (
                <div
                  key={tab.key}
                  style={{ display: activeTab === tab.key ? "block" : "none" }}
                >
                  <tab.component />
                </div>
              ) : null
            )}
          </div>
        </div>
      </div>
    </MainComponent>
  );
}

export default MasterPricing;
